import script from "./HTML0001.vue?vue&type=script&setup=true&lang=js"
export * from "./HTML0001.vue?vue&type=script&setup=true&lang=js"

import "./HTML0001.vue?vue&type=style&index=0&id=c090519a&lang=css"

const __exports__ = script;

export default __exports__